import { gql, TypedDocumentNode } from '@apollo/client'
import {
  BackofficeRemoveActiveHealthPartnerDataInterface,
  BackofficeRemoveActiveHealthPartnerInputInterface,
} from './interface'

const backofficeRemoveActiveHealthPartner: TypedDocumentNode<
  BackofficeRemoveActiveHealthPartnerDataInterface,
  BackofficeRemoveActiveHealthPartnerInputInterface
> = gql`
  mutation BackofficeRemoveActiveHealthPartner($activeHealthPartnerId: ID!) {
    backofficeRemoveActiveHealthPartner(activeHealthPartnerId: $activeHealthPartnerId) {
      code
      message
      data
    }
  }
`

export default backofficeRemoveActiveHealthPartner
